const PENDING_PAYMENT_METHOD = 'PENDIENTEDEPAGO'

const normalizePaymentMethod = value =>
  String(value || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')

export const hasPendingOrEmptyPaymentMethod = paymentMethod => {
  if (
    paymentMethod == null ||
    paymentMethod === '' ||
    (Array.isArray(paymentMethod) && paymentMethod.length === 0)
  ) {
    return true
  }

  const paymentMethods = Array.isArray(paymentMethod)
    ? paymentMethod
    : [paymentMethod]

  return paymentMethods.some(payment => {
    if (typeof payment === 'string') {
      return normalizePaymentMethod(payment) === PENDING_PAYMENT_METHOD
    }

    const currentPaymentMethod =
      payment?.PaymentTypeId ||
      payment?.PaymentMethodId ||
      payment?.PaymentMethodDetails?.PaymentTypeId ||
      payment?.PaymentMethodDetails?.PaymentMethodId

    return (
      normalizePaymentMethod(currentPaymentMethod) === PENDING_PAYMENT_METHOD ||
      Object.keys(payment || {}).some(
        key => normalizePaymentMethod(key) === PENDING_PAYMENT_METHOD
      )
    )
  })
}
